export default "/provide-liquidity.12678446bdfae0b97b0906b7ca3def0d.png";